<p-sidebar
  class="main-toolbar-overlay"
  #sidebarRef
  [showCloseIcon]="false"
  [blockScroll]="true"
  position="left"
  [modal]="false"
  [styleClass]="sidebarService.toolOverlayClasses$()"
  [(visible)]="openSidebar"
  (onHide)="onOverlayClose()">
  <ng-template pTemplate="header">
    <div class="flex flex-column gap-2 w-full">
      <div class="flex justify-content-between">
        <app-header
          [text]="sidebarService.headerContent$()"
          [icon]="sidebarService.icon$()"
          [sub]="sidebarService.subtitleContent$()"></app-header>
        <p-button
          (onClick)="closeCallback($event)"
          class="ml-auto"
          size="small"
          severity="secondary"
          badge="esc"
          badgeClass="kbd"
          icon="fas fa-xmark-circle"
          [rounded]="true"
          label="schließen"
          [outlined]="true">
        </p-button>
      </div>

      @if (sidebarService.subMenu$(); as quickLinks) {
        <div class="flex gap-2 -ml-2 align-items-center -mt-3">
          @for (quickLink of quickLinks; track $index) {
            <p-button
              [styleClass]="'p-button-xs button-light px-1 gap-0'"
              [text]="true"
              [badge]="quickLink.badge"
              badgeClass="p-badge-danger"
              [label]="quickLink.label"
              [icon]="quickLink.icon"
              [severity]="quickLink.severity"
              [routerLink]="quickLink.routerLink"
              [rounded]="true"></p-button>
          }
        </div>
      }
    </div> </ng-template
  ><router-outlet name="overlay"></router-outlet>
  <ng-template pTemplate="footer">
    @if (sidebarService.quickLinks$(); as quickLinks) {
      <div
        class="flex gap-2 justify-content-end border-top-1 surface-border pt-3">
        @for (quickLink of quickLinks; track $index) {
          <p-button
            size="small"
            [class]="quickLink.styleClass"
            [raised]="true"
            [text]="true"
            [label]="quickLink.label"
            [icon]="quickLink.icon"
            [severity]="quickLink.severity"
            [routerLink]="quickLink.routerLink"
            [rounded]="true"></p-button>
        }
      </div>
    }
  </ng-template>
</p-sidebar>
<app-mask [visible]="openSidebar" (click)="onOverlayClose()"></app-mask>
